// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Picto } from '../../../../assets/svg/grid-new.svg';
import { __ } from '../../../../i18n/l10n';
import { BetslipDisplayStatuses } from '../../../../types/betslip';
import type { BetslipDisplayStatus } from '../../../../types/betslip';
import type { GridMatchLength } from '../../types';

const Title = styled.p`
  color: #fff;
  text-align: center;
  text-transform: uppercase;
`;

const StyledPicto = styled(Picto)`
  width: 1.2em;
  height: 1.2em;
  stroke: #fff;
  fill: none;
  margin: 0 0.6em 0 0;
  transform: translateY(15%);
`;

const Colored = styled.span`
  color: ${({ $status, theme }) => {
    if ($status === BetslipDisplayStatuses.WINNING) {
      return theme.grids.colors.greenwin;
    }
    if ($status === BetslipDisplayStatuses.LOST) {
      return theme.grids.colors.redlight;
    }
    if ($status === BetslipDisplayStatuses.RUNNING) {
      return theme.grids.colors.yellow;
    }
    if ($status === BetslipDisplayStatuses.CANCELLED) {
      return theme.grids.colors.middlegrey2;
    }
    return theme.grids.colors.redlight;
  }};
`;

const PoolType = styled.span`
  display: inline-block;
  border-radius: 50%;
  margin-right: 0.4em;
  background: ${({ theme }) => theme.grids.colors.darkgrey4};
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  width: 1.5em;
  height: 1.5em;
  text-align: 1;
`;

type Props = {
  className?: string;
  poolNumber: number;
  withPicto: boolean;
  status?: BetslipDisplayStatus;
  poolType?: GridMatchLength;
};

const PoolTitle = ({ className, poolNumber, withPicto, status = null, poolType }: Props) => {
  return (
    <Title className={className}>
      {withPicto && <StyledPicto className="grid-picto" />}
      {__('Grid')} {poolType && <PoolType>{poolType}</PoolType>}
      <Colored $status={status}>{`${__('n°')} ${poolNumber}`}</Colored>
    </Title>
  );
};

export default PoolTitle;
